const pt_BR = {
  translations: {
    home: {
      message: "Olá Mundo",
    },
    page: {
      totem_start: {
        environment: "Ambiente",
        code: "Código",
        password: "Senha",
        enter: "Entrar",
        version: "Versão",
        developed_by: "Desenvolvido pela ",
        platform: "Plataforma 4uHub",
        errors: {
          environment: "O ambiente é obrigatório",
          login: "O login é obrigatório",
          password: "A senha é obrigatória",
        },
      },
      mainMenu: {
        welcome: "Seja bem-vindo",
        need_help: "Vou precisar de ajuda para ser atendido:",
        password_button: "Senha fila atendimento",
        can_do_it: "Consigo fazer sozinho meu atendimento:",
        check_in_button: "Check-In",
        schedule_button: "Agendamento de consultas e exames",
        totem: "Totem de Atendimento",
        thanks: "Obrigado por usar nosso serviço!",
      },
      login: {
        welcome: "Bem-vindo de volta",
        username: "Nome de usuário",
        cpf: "CPF",
        password: "Senha",
        rememberme: "Lembre de mim",
        forget_password: "Esqueceu a senha?",
        dont_account: "Não tem uma conta? Registre-se",
        login: "Acessar",
        confirm_email: "Confirmar e-mail",
        errors: {
          login: "O login é obrigatório",
          password: "A senha precisa de no mínimo 6 caracteres",
        },
      },
      loginTemporary: {
        welcome: "Seja bem-vindo(a)",
        login: "Login",
        password: "Senha",
        dont_account: "Não tem uma conta? Registre-se",
        access_button: "Acessar",
        access_exam: "Acesso Exames",
        errors: {
          login: "O login é obrigatório",
          password: "A senha é obrigatória",
        },
      },
      not_found: {
        page_not_found: "Ooops! Página não encontrada",
        back_to_begin: "Voltar ao início",
        server_not_responding: "O servidor não está respondendo",
        try_again: "Tente novamante",
        back_to_login: "Voltar ao login",
        something_went_wrong: "Algo deu errado :(",
      },

      register: {
        register: "Cadastre-se",
        document: "CPF",
        has_register: "Já tem cadastro? Acesse sua conta",
        birth_date: "Data de Nascimento",
        email: "E-mail",
        confirm_email: "Confirmar e-mail",
        password: "Senha",
        confirm_password: "Confirmar senha",
        notification: "Cadastrado com sucesso",
        errors: {
          document: "O CPF é obrigatório",
          password: "A senha é obrigatória",
          email: "O e-mail é obrigatório",
          confirm_email: "Os e-mails precisam ser iguais",
          confirm_password: "As senhas precisam ser iguais",
          birth_date: "A data de nascimento é obrigatória",
        },
        emailSendMessage:
          "Enviamos um email para confirmar a criação da conta. Por favor verifique a aba de spam :)",
        backToLogin: " Voltar para o login",
        individuals: {
          contacts: "Contatos",
          contact_type: "Tipo de contato",
          add_contact: "Adicionar contato",
          addresses: "Endereços",
          add_address: "Adicionar endereço",
        },
      },

      changePassword: {
        change_password: "Alterar senha",
        actual_password: "Senha atual",
        new_password: "Nova senha",
        save: "Salvar",
        confirm_new_password: "Confirmar nova senha",
        success_message: "Senha alterada com sucesso",
        errors: {
          actual_password: "A senha atual é obrigatória",
          new_password: "A nova senha é obrigatória",
          confirm_new_password: "O confirmar nova senha é obrigatório",
          passwords_match: "As senhas não coincidem",
        },
      },
      confirm_email: {
        confirm_email: "Confirmar e-mail",
        confirming: "Confirmando",
        subtitle:
          'Insira abaixo o código recebido por e-mail e então clique em "Confirmar e-mail".',
        username: "Nome de usuário",
        document: "CPF",
        code: "Código",
        resent: "E-mail reenviado com sucesso",
        success: {
          title: "Email Confirmado",
          description:
            "O seu email foi confirmado com sucesso, volte para o login para acessar sua conta",
        },
        error: {
          username: "O {{username}} é obrigatório",
          title: "Houve um erro",
          description: "Ocorreu um erro ao confirmar o email, tente novamente",
          action: "Reenviar email",
          code: "O Código é obrigatório",
        },
      },

      noAccess: {
        message:
          "Ops! Parece que você não possui permissão para acessar essa página!",
        button: "Voltar para o início",
      },
    },

    components: {
      menu: {},
      backButton: "Voltar",
      private: {
        permission: "Ooops! Você não tem permissão!",
      },
      forgetPasswordForm: {
        title: "Esqueceu a senha?",
        subtitle:
          "Insira seu CPF abaixo e enviaremos um código no seu e-mail para a recuperação de senha.",
        button: "Enviar",
        login: "CPF",
        login_required: "O campo CPF é obrigatório!",
        notification_email_sent: "Email enviado com sucesso!",
        back_login: "Voltar para o login",
        notification_email_confirmed:
          "E-mail confirmado com sucesso, por favor informe seus dados de acesso novamente.",
      },
      resetPasswordForm: {
        title: "Nova senha",
        subtitle:
          "Digite  o código enviado para seu email. Se não encontrá-lo verifique a área de spam.",
        password: "Senha",
        confirm_password: "Confirmar senha",
        confirmation_code: "Código de confirmação",
        new_password_required: "O campo senha é obrigatório.",
        confirm_new_password_required:
          "O campo de confirmar senha é obrigatório.",
        passwords_match: "As senhas não coincidem.",
        confirmation_code_required: "O código de confirmação é obrigatório",
        notification_password_success: "Senha alterada com sucesso!",
        counter: "Reenviar e-mail disponível em {{counter}} segundo(s)",
      },
      themeSwitch: {
        change_theme: "Mudar tema",
      },
      languageSwitch: {
        change_language: "Mudar idioma",
      },
      changeLanguageForm: {
        title: "Alterar idioma",
        language: "Idioma",
        button: "Alterar",
      },

      autocomplete: {
        noOptions: "Sem opções",
        hint: "Insira ao menos 3 caracteres para pesquisar",
      },
      logout: "Sair",
      no_data: "Sem dados para exibir",
      resendEmail: {
        title: "Parece que você ainda não confirmou seu e-mail",
        description:
          "Clique no botão abaixo para reenviar o email de confirmação.",
        button: "Reenviar e-mail",
        success: "E-mail reenviado com sucesso!",
      },
      registeredModal: {
        title: "Cadastro realizado com sucesso!",
        description:
          "Por favor, clique no botão abaixo e, após, siga os passos para realizar a confirmação do seu e-mail.",
        button: "Ok",
      },
      emailConfirmedModal: {
        title: "E-mail confirmado com sucesso!",
        description:
          "Agora você já pode acessar sua conta, basta clicar no botão abaixo e seguir os passos para acessar sua conta.",
        button: "Ok",
      },
      emailResent: {
        title: "E-mail reenviado com sucesso!",
        description:
          "Reenviamos o código para o e-mail cadastrado, cheque seu e-mail, copie o código de confirmação, clique no botão abaixo e siga os passos para confirmar seu e-mail.",
        button: "Ok",
      },
      registerError: {
        button: "Ok",
      },
      emailErrorCode: {
        title: "Código inválido",
        description:
          "Por favor verifique o código, ou tente reenviar o e-mail.",
        button: "ok",
      },
      noRowsMessage: {
        no_permission:
          "Você não possui permissão para acessar essas informações",
        no_data: "Sem dados para exibir",
      },
    },
    logout: "Sair",
    change_password: "Alterar senha",
    change_language: "Alterar idioma",
    access_denied: "Você precisa estar conectado para acessar esta pagina",
    login_expired: "Sua sessão expirou.Logue Novamente",
  },
};

export default pt_BR;
